import React from "react";
import { useActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";

function Filter() {
    const { deckEditorFilter } = useTypedSelector(state => state.auth);
    const { setDeckEditorFilter } = useActions();

    const type = deckEditorFilter?.type ?? "all";
    const rarity = deckEditorFilter?.rarity ?? "all";

    const setType = (filter: string) => {
        setDeckEditorFilter({
            ...deckEditorFilter,
            type: filter,
        });
    };

    const setRarity = (filter: string) => {
        setDeckEditorFilter({
            ...deckEditorFilter,
            rarity: filter,
        });
    };

    return (
        <div className="libFilterContainer">

            <div className="deckFilterCaption">Type:</div>
            <select
                className="deckFilterType"
                name="deckFilterTypeName"
                value={type}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                onPointerDown={(e) => e.stopPropagation()}
                onChange={(e) => setType(e.target.value)}
            >
                <option value="all">All</option>
                <option value="spell">Spell</option>
                <option value="unit">Unit</option>
                <option value="mana_card">Mana card</option>
            </select>

            <div className="deckFilterCaption deckFilterCaptionRarity">Rarity:</div>
            <select
                className="deckFilterRarity"
                name="deckFilterRarityName"
                value={rarity}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                onPointerDown={(e) => e.stopPropagation()}
                onChange={(e) => setRarity(e.target.value)}
            >
                <option value="all">All</option>
                <option value="1">Common</option>
                <option value="2">Uncommon</option>
                <option value="3">Rare</option>
                <option value="4">Mythic</option>
            </select>

        </div>
    );
}

export default Filter;